import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { fg } from '@atlaskit/platform-feature-flags';
import { Anchor } from '@atlaskit/primitives/compiled';
import { useAnalyticsEvents } from '../../common/analytics/generated/use-analytics-events';
import { CONTENT_URL_3P_ACCOUNT_AUTH, CONTENT_URL_SECURITY_AND_PERMISSIONS } from '../../constants';
import { messages } from '../../messages';
var cohortMessages = {
  control: messages.connect_unauthorised_account_description,
  test1: messages.experiment_connect_hovercard_description_1,
  test2: messages.experiment_connect_hovercard_description_2,
  test3: messages.experiment_connect_hovercard_description_3,
  test4: messages.connect_unauthorised_account_description
};

/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */
var UnauthorisedViewContent = function UnauthorisedViewContent(_ref) {
  var providerName = _ref.providerName,
    isProductIntegrationSupported = _ref.isProductIntegrationSupported,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'unauthorised-view-content' : _ref$testId,
    appearance = _ref.appearance;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    fireEvent = _useAnalyticsEvents.fireEvent;
  var handleLearnMoreClick = useCallback(function () {
    fireEvent('ui.button.clicked.learnMore', {});
  }, [fireEvent]);
  var hoverCardExperimentCohort = providerName === 'Google' && appearance === 'hoverCardPreview' ? FeatureGates.getExperimentValue('platform_editor_google_hovercard_experiment', 'cohort', 'control') : 'control';
  var learnMoreMessage;
  if (isProductIntegrationSupported) {
    if (hoverCardExperimentCohort === 'control') {
      learnMoreMessage = fg('product-terminology-refresh') ? messages.learn_more_about_connecting_account_appify : messages.learn_more_about_connecting_account;
    } else {
      learnMoreMessage = messages.experiment_learn_more_about_smart_links;
    }
  } else {
    learnMoreMessage = messages.learn_more_about_smart_links;
  }
  var unauthorizedAccountDescriptionMessage;
  if (hoverCardExperimentCohort === 'control') {
    unauthorizedAccountDescriptionMessage = fg('product-terminology-refresh') ? messages.connect_unauthorised_account_description_appify : messages.connect_unauthorised_account_description;
  } else {
    unauthorizedAccountDescriptionMessage = cohortMessages[hoverCardExperimentCohort];
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, providerName ? /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, unauthorizedAccountDescriptionMessage, {
    values: {
      context: providerName
    }
  })) : /*#__PURE__*/React.createElement(FormattedMessage, fg('product-terminology-refresh') ? messages.connect_unauthorised_account_description_no_provider_appify : messages.connect_unauthorised_account_description_no_provider), ' ', /*#__PURE__*/React.createElement(Anchor, {
    href: isProductIntegrationSupported ? CONTENT_URL_3P_ACCOUNT_AUTH : CONTENT_URL_SECURITY_AND_PERMISSIONS,
    target: "_blank",
    testId: "".concat(testId, "-learn-more"),
    onClick: handleLearnMoreClick
  }, /*#__PURE__*/React.createElement(FormattedMessage, learnMoreMessage)));
};
export default UnauthorisedViewContent;